export const MAX_PERCENTAGE = 100;
export const isValidPriceInput = (input) => {
    return !!input && input !== "" && !isNaN(Number(input));
};
export const calculatePriceDifference = (suggestedPrice, originalPrice) => {
    return ((suggestedPrice - originalPrice) / originalPrice) * 100;
};
export const formatPriceInput = (value) => {
    return value.replace(/[^0-9]/g, "");
};
export const formatPriceOutput = (percentageDifference) => {
    if (percentageDifference === MAX_PERCENTAGE)
        return `+${MAX_PERCENTAGE}%`;
    if (percentageDifference > MAX_PERCENTAGE)
        return `>${MAX_PERCENTAGE}%`;
    if (percentageDifference <= -MAX_PERCENTAGE)
        return `-${MAX_PERCENTAGE}%`;
    const sign = percentageDifference > 0 ? "+" : "";
    return `${sign}${percentageDifference.toFixed(1)}%`;
};
